(function () {

  let main = {}

  // Clone dropdown

  const tooltipTriggerEl = document.querySelector('#copyButton')
  if (tooltipTriggerEl) {
    new bootstrap.Tooltip(tooltipTriggerEl, {trigger: 'manual'})
  }

  main.copyToClipboard = function (event) {
    const input = document.querySelector('.form-control');
    input.select();
    document.execCommand('copy');

    // Show tooltip
    const copyButton = document.getElementById('copyButton');
    const tooltip = bootstrap.Tooltip.getInstance(copyButton);
    tooltip.show();

    // Hide tooltip after 1.5 seconds
    setTimeout(() => {
        tooltip.hide();
    }, 1500);
  }

  main.copyTextToClipboard = function (text, buttonEl) {
    const textarea = document.createElement('textarea');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);

    if (buttonEl) {
      const tooltip = bootstrap.Tooltip.getOrCreateInstance(buttonEl, {trigger: 'manual'});
      tooltip.show();
      setTimeout(() => tooltip.hide(), 1500);
    }
  }

  // end clone dropdown

  var fsetTmpl
  var newNum = 0

  main.initFieldList = function (el) {
    initCollapseAll(el)
    if (! _.config.ENABLE_JS_LIST) {
      return
    }
    // For AJAX mode, we don't need to clone templates anymore
    // The subforms will be fetched from the server on demand
    // Just initialize with any existing fields
  }

  main.listFieldAdd = function (el) {
    console.log('[listFieldAdd] Called with element:', el)

    if (! _.config.ENABLE_JS_LIST) {
      console.log('[listFieldAdd] Non-AJAX mode, using hidden fields')
      var $item
      $item = $(el).parent().find('fieldset.d-none').first()
      $item.removeClass('d-none')
      $item.find('[id$=disabled]').remove()
      return
    }

    console.log('[listFieldAdd] AJAX mode enabled')

    // Get field list metadata from the fieldset element
    const fieldset = $(el).closest('fieldset[data-field-name]')
    console.log('[listFieldAdd] Found fieldset:', fieldset[0])

    // Find the .fset-container that's a sibling (previous element) of this button
    // The button is after the container in the DOM structure
    const fsetContainer = $(el).prevAll('.fset-container').first()
    console.log('[listFieldAdd] Found container:', fsetContainer[0])

    // Extract site, collection, and doc name from the page URL
    // Format: /sites/{site_slug}/doc/edit/{branch}/{coll_name}/{doc_name}
    //     or: /sites/{site_slug}/doc/new/{branch}/{coll_name}
    const pathParts = window.location.pathname.split('/')
    const siteName = pathParts[2]  // site_slug
    const collName = pathParts[6]  // coll_name (after /doc/edit|new/branch/)
    // pathParts[4] is 'edit', 'delete', or 'new'
    let docName = ''
    if (pathParts[4] === 'edit' || pathParts[4] === 'delete') {
      docName = pathParts.slice(7).join('/')  // doc_name (may have slashes)
    }
    console.log('[listFieldAdd] Site:', siteName, 'Collection:', collName, 'Doc:', docName)

    // Get field name and short name from data attributes
    const fieldName = fieldset.data('field-name')
    const fieldShortName = fieldset.data('field-short-name')
    console.log('[listFieldAdd] Field name:', fieldName)
    console.log('[listFieldAdd] Field short name:', fieldShortName)

    if (!fieldName) {
      console.error('[listFieldAdd] Field name not found on fieldset')
      console.error('[listFieldAdd] Fieldset attributes:', fieldset[0].attributes)
      alert('Unable to add new item. Field name is missing.')
      return
    }

    // Calculate the next index based on existing subforms
    // Use children() to get only direct child fieldsets (not nested ones)
    const existingFields = fsetContainer.children('fieldset.list-field')
    console.log('[listFieldAdd] Existing fields count:', existingFields.length)
    const nextIndex = existingFields.length

    // Build the request payload
    const payload = {
      index: nextIndex,
      field_short_name: fieldShortName || fieldName,
      parent_field_name: fieldName,
      doc_name: docName  // For DecapFileCollection
    }
    console.log('[listFieldAdd] Request payload:', payload)

    // Make AJAX request to get the HTML for the new subform
    // Use fieldName as the path, which includes parent indices for nested fields
    const url = `/sites/render-subform/${siteName}/${collName}/${fieldName}`
    console.log('[listFieldAdd] Fetching from URL:', url)

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      console.log('[listFieldAdd] Response status:', response.status)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
    .then(data => {
      console.log('[listFieldAdd] Response data:', data)
      if (data.html) {
        console.log('[listFieldAdd] Appending HTML to container')
        // Append the new subform HTML
        fsetContainer.append(data.html)
        console.log('[listFieldAdd] HTML appended successfully')

        // Get the newly added fieldset (no special handling needed)
        console.log('[listFieldAdd] Subform added and ready for input')

        // Re-initialize sortable if needed
        const sortableEl = fsetContainer[0]
        if (sortableEl && typeof Sortable !== 'undefined') {
          console.log('[listFieldAdd] Re-initializing Sortable')
          new Sortable(sortableEl, {animation: 150, handle: '.js-sortable-handle'})
        }
      } else if (data.error) {
        console.error('[listFieldAdd] Server returned error:', data.error)
        alert('Failed to add new item: ' + data.error)
      } else {
        console.error('[listFieldAdd] Unexpected response format:', data)
        alert('Failed to add new item. Unexpected response format.')
      }
    })
    .catch(error => {
      console.error('[listFieldAdd] Fetch error:', error)
      console.error('[listFieldAdd] Error stack:', error.stack)
      alert('Failed to add new item: ' + error.message)
    })
  }

  main.listFieldRemove = function (el) {
    _.rollupRemove($(el).closest('.list-field')[0])
  }

  var ACCEPT_MAP = {
    image: 'image/*',
    video: 'video/*',
  }

  function refreshGlightbox() {
    if (window._glightbox) window._glightbox.destroy()
    if (typeof GLightbox !== 'undefined') {
      window._glightbox = GLightbox({ selector: '.glightbox' })
    }
  }

  function updateThumbnail(data, refs, attributes) {
    var wrapper = refs.url_input.closest('[data-file-field]')
    if (!wrapper) return
    var link = wrapper.querySelector('a.glightbox')
    if (link) {
      link.href = attributes.href
      var img = link.querySelector('img')
      var source = link.querySelector('video source')
      if (img) img.src = attributes.href
      if (source) source.src = attributes.href
    } else if (attributes.href) {
      var thumbContainer = wrapper.querySelector('div.me-3')
      var media = thumbContainer.querySelector('img, video')
      if (media) {
        var a = document.createElement('a')
        a.href = attributes.href
        a.className = 'glightbox'
        a.dataset.type = data.ctype === 'video' ? 'video' : 'image'
        if (data.ctype === 'video') a.dataset.source = 'local'
        media.style.cursor = 'pointer'
        media.parentNode.insertBefore(a, media)
        a.appendChild(media)
        if (media.tagName === 'IMG') media.src = attributes.href
        else {
          var s = media.querySelector('source')
          if (s) s.src = attributes.href
        }
      }
    }
    refreshGlightbox()
  }

  main.onUploadClick = function (data, refs) {
    var file_id = data.field_id + "-file"
    var accept = ACCEPT_MAP[data.ctype] || ''
    var acceptAttr = accept ? ` accept="${accept}"` : ''
    var file_input = `<input id="${file_id}" x-on:change="main.onFileChange($data, $refs)" type="file"${acceptAttr} />`
    refs.hidden.insertAdjacentHTML('beforeend', file_input)
    document.getElementById(file_id).click()
  }

  main.onFileChange = function (data, refs) {
    var file_input, file, upload_url

    function showProgress() {
      $(refs.progressBar).css('width', '0%')
      $(refs.progress).removeClass('d-none')
    }

    function setProgress(progress) {
      $(refs.progressBar).css('width', progress + '%')
    }

    function hideProgress() {
      $(refs.progress).addClass('d-none')
    }

    function setAttributes(attributes) {
      $(refs.url_input).val(attributes.href)
      updateThumbnail(data, refs, attributes)
      hideProgress()
    }

    function onError() {
      hideProgress()
    }

    showProgress()
    upload_url = data.upload_url
    file_input = $(refs.hidden).find('input')[0]
    if (file_input.files) {
      file = file_input.files[0]
      uploadFile(file, upload_url, setProgress, setAttributes, onError)
    }
  }

  function uploadFile (file, upload_url, progressCallback, successCallback, errorCallback) {
    const params = {
      name: file.name,
      type: file.type
    }
    fetch(_.appendQueryArgs(upload_url, params))
      .then(response => response.json()
        .then(formobj => postToBucket(file, formobj, progressCallback, successCallback, errorCallback)))
  }
  main.uploadFile = uploadFile

  function postToBucket(file, formobj, progressCallback, successCallback, errorCallback) {
    var formData = createFormData(file, formobj.fields)
    var xhr = new XMLHttpRequest()

    xhr.open("POST", formobj.url, true)

    xhr.upload.addEventListener("progress", function(event) {
      var progress = event.loaded / event.total * 100
      progressCallback(progress)
    })

    xhr.addEventListener("load", function(event) {
      if (xhr.status != 204) {
        if (errorCallback) errorCallback()
        _.alert('Upload failed. Make sure the file type matches the field type (e.g. image fields only accept images).', 'danger')
        return
      }
      // proxy_url must be provided by the server
      if (!formobj.proxy_url) {
        if (errorCallback) errorCallback()
        console.error("Server error: proxy_url not provided in upload response")
        return
      }
      var attributes = {
        url: formobj.proxy_url,
        href: formobj.proxy_url,
        name: false,
        size: false
      }
      successCallback(attributes)
    })

    xhr.addEventListener("error", function(event) {
      if (errorCallback) errorCallback()
      _.alert('Upload failed due to a network error.', 'danger')
    })

    xhr.send(formData)
  }

  function createFormData(file, fields) {
    var data = new FormData()
    for (const [key, value] of Object.entries(fields)) {
      data.append(key, value)
    }
    data.append("file", file)
    return data
  }

  function initSortable() {
    document.querySelectorAll(".js-sortable").forEach(el => {
      new Sortable(el, {animation: 150, handle: '.js-sortable-handle'})
    })
  }

  function initCollapseAll(parent) {

    const collapseBtn = parent.querySelector(".js-collapse-all")
    collapseBtn.addEventListener('click', () => {
      parent.querySelectorAll('.collapse').forEach(el => {
        const collapse = bootstrap.Collapse.getOrCreateInstance(el)
        collapse.hide()
      })
    })
    const expandBtn = parent.querySelector(".js-expand-all")
    expandBtn.addEventListener('click', () => {
      parent.querySelectorAll('.collapse').forEach(el => {
        const collapse = bootstrap.Collapse.getOrCreateInstance(el)
        collapse.show()
      })
    })

    document.querySelectorAll(".js-card-title").forEach(elTitle => {
      const elInput = elTitle.closest(".card").querySelector('input[type="text"]')
      if (elInput) {
        elTitle.textContent = elInput.value
        elInput.addEventListener('input', () => {
          elTitle.textContent = elInput.value
        })
      }
    })

  }

  main.initManagementList = function (el) {
    if (typeof Sortable === 'undefined') return
    var container = el.querySelector('.js-sortable-items')
    if (!container) return
    var reorderUrl = container.dataset.reorderUrl
    if (!reorderUrl) return
    new Sortable(container, {
      animation: 150,
      handle: '.js-sortable-handle',
      onEnd: function () {
        var order = Array.from(container.children).map(function (el) {
          return el.dataset.idx
        })
        var form = document.createElement('form')
        form.method = 'POST'
        form.action = reorderUrl
        // Copy CSRF token from meta tag or any existing form
        var csrfInput = document.querySelector('input[name="csrf_token"]')
        if (csrfInput) {
          var hidden = document.createElement('input')
          hidden.type = 'hidden'
          hidden.name = 'csrf_token'
          hidden.value = csrfInput.value
          form.appendChild(hidden)
        }
        // Pass through next_url so the server can redirect back
        var nextUrl = container.dataset.nextUrl
        if (nextUrl) {
          var nextInput = document.createElement('input')
          nextInput.type = 'hidden'
          nextInput.name = 'next_url'
          nextInput.value = nextUrl
          form.appendChild(nextInput)
        }
        order.forEach(function (idx) {
          var input = document.createElement('input')
          input.type = 'hidden'
          input.name = 'order'
          input.value = idx
          form.appendChild(input)
        })
        document.body.appendChild(form)
        form.submit()
      }
    })
  }

  main.initTooltip = function (el) {
    new bootstrap.Tooltip(el)
  }

  main.initCopyLink = function (el) {
    const originalTitle = el.getAttribute('title') || 'Copy link'
    const tooltip = new bootstrap.Tooltip(el)
    el.addEventListener('click', function () {
      main.copyTextToClipboard(el.dataset.copyUrl)
      tooltip.hide()
      el.setAttribute('data-bs-original-title', 'Copied!')
      tooltip.show()
      setTimeout(function () {
        tooltip.hide()
        el.setAttribute('data-bs-original-title', originalTitle)
      }, 1500)
    })
  }

  main.initClickableRow = function (tr) {
    const link = tr.querySelector('[data-click-target]')
    if (!link) return
    const href = link.getAttribute('href')
    tr.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey) return
      window.location = href
    })
    tr.addEventListener('mousedown', function (e) {
      if (e.metaKey || e.ctrlKey) {
        window.open(href, '_blank')
        e.preventDefault()
      }
    })
  }

  document.addEventListener("DOMContentLoaded", function () {
    initSortable()
    const elInitList = document.querySelectorAll('[data-init]')
    elInitList.forEach(el => {
      const fn = main[el.dataset.init]
      fn(el)
    });
    if (typeof GLightbox !== 'undefined') {
      window._glightbox = GLightbox({ selector: '.glightbox' })
    }
  })

  if (typeof jQuery !== 'undefined') {
    jQuery.noConflict()
    jQuery(document).ready(function ($) {
      $('[data-jqinit=summernote]').each(function() {
        let $el = $(this)

        function onImageUpload (files) {
          attachments.handleSummerUpload(files, $el)
        }

        let summerConfig = {
          lang: 'en-US',
          callbacks: {
            onImageUpload: onImageUpload
          }
        }
        $el.summernote(summerConfig)
      })
    })
  }

  addEventListener("trix-attachment-add", attachments.handleTrixUpload)

  window.main = main

})();
